import React from "react";
import { HintsLink } from "../../../modules/hints/components/HintsLink";
import Config from "../config";

const LegalNotice = ({ lang }: { lang: string }) => {
  if (lang === "de") {
    return (
      <div className="min-h-full px-5 text-foreground gap-4 flex flex-col">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center">
          Impressum
        </h1>
        <p>
          <b>Herausgeber</b>
          <br />
          kolula solutions UG (haftungsbeschränkt)
          <br />
          c/o SchneiderGolling & Cie. AG
          <br />
          Niederkasseler Lohweg 18
          <br />
          40547 Düsseldorf
          <br />
          <br />
          Telefonnummer:{" "}
          <HintsLink href={`tel:${Config.contact.phone}`}>{Config.contact.phone}</HintsLink>
          <br />
          E-Mail:{" "}
          <HintsLink href="mailto:support@kolula.com">
            support@kolula.com
          </HintsLink>
          <br />
          Website:{" "}
          <HintsLink
            href="https://kolula-sup.com"
            rel="noopener"
            target="_blank"
          >
            https://kolula-sup.com
          </HintsLink>
        </p>
        <p>
          <strong>Vertretungsberechtigter Vorstand:</strong>
          <br />
          Melanie Bockemühl
          <br />
          <br />
          Registergericht: Düsseldorf
          <br />
          Registernummer: HRB 16133 FL
          <br />
          Umsatzsteuer-Identifikationsnummer gemäß §27a UStG: DE358934802
          <br />
          <br />
          Inhaltlich Verantwortlicher gemäß § 55 Absatz 2 RStV: Melanie
          Bockemühl
        </p>
      </div>
    );
  } else {
    return (
      <div className="min-h-full px-5 text-foreground gap-4 flex flex-col">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center">
          Legal Notice
        </h1>
        <p>
          <b>Publisher</b>
          <br />
          kolula solutions UG (haftungsbeschränkt)
          <br />
          c/o SchneiderGolling & Cie. AG
          <br />
          Niederkasseler Lohweg 18
          <br />
          40547 Düsseldorf
          <br />
          <br />
          Phone: <HintsLink href={`tel:${Config.contact.phone}`}>{Config.contact.phone}</HintsLink>
          <br />
          Email:{" "}
          <HintsLink href="mailto:support@kolula.com">
            support@kolula.com
          </HintsLink>
          <br />
          Website:{" "}
          <HintsLink
            href="https://kolula-sup.com"
            rel="noopener"
            target="_blank"
          >
            https://kolula-sup.com
          </HintsLink>
        </p>
        <p>
          <strong>Authorized Board Members:</strong>
          <br />
          Melanie Bockemühl
          <br />
          <br />
          Commercial Register: Düsseldorf
          <br />
          Registration Number: HRB 16133 FL
          <br />
          VAT ID according to §27a UStG: DE358934802
          <br />
          <br />
          Content Responsible according to § 55 Paragraph 2 RStV: Melanie
          Bockemühl
        </p>
      </div>
    );
  }
};

export default LegalNotice;
